
import TrackerSelect from './tracker-select.vue'
import {markRaw} from 'vue'
import TrackerDelete from './tracker-delete.vue'
import $contacts2 from 'stores/contacts2'
import ContactTile from '../contact-tile.vue'
import PulseNum from '../pulse-num.vue'
import RolesViewer from './roles-viewer.vue'
import {$contacts_groups} from 'stores/contacts2'

export default {
  components: {
    TrackerSelect,
    TrackerDelete,
    ContactTile,
    RolesViewer,
    PulseNum
  },
  props: {
    hover: {
      type: Boolean,
      default: false
    },  
    companyId: {
      type: String,
      required: true
    },
    contact: {
      type: Object,
      required: true,
      // Expected structure: {id, first_name, last_name, tracker_focus, tracker_alerts, position, tracker_roles, created_at}
    },
    trackerWidth: {
      type: Number,
      default: undefined
    }
  },
  emits: ['delete'],
  data(){
    return {
      TRACKER_OPTS: markRaw([
        {
          title: 'Edit person',
          icon: 'building-02',
          color: 'var(--brand-50)',
          onClick: () => this.$dispatch('edit-person', {contact_id: this.contact.id, company_id: this.companyId})
        },
        {
          title: 'Delete person',
          icon: 'trash-2',
          color: 'var(--brand-50)',
          onClick: () => this.onDelete()
        },
      ]),
    }
  },
  computed: {
    roles_count() {
      if (this.trackerWidth > 800) {
        return 4
      }
      if (this.trackerWidth > 700) {
        return 3
      }
      return 2
    }
  },
  methods: {
    async onDelete() {
      const tracker = await $contacts2.loadContact(this.contact.id)
      this.$refs.delete.open(tracker)
    },

    onDeleted(){
      $contacts_groups.deleteContact(this.contact)
    }
  }
}
